import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

export function RouteErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <div style={{ padding: '2rem', color: 'black' }}>
        <h1>Oops! Something went wrong.</h1>
        <p>
          {error.status} - {error.statusText}
        </p>
        {error.data && <pre>{String(error.data)}</pre>}
      </div>
    );
  }

  if (error instanceof Error) {
    return (
      <div style={{ padding: '2rem', color: 'black' }}>
        <h1>Unexpected Application Error</h1>
        <p>{error.message}</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '2rem', color: 'black' }}>
      <h1>Something went wrong.</h1>
      <p>Please refresh the page and try again.</p>
    </div>
  );
}
